// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Switcher_wrapper__1XcEk","label":"Switcher_label__pU9EB","switch":"Switcher_switch__ZE_Lz","input":"Switcher_input__Pk5a7","slider":"Switcher_slider__qTqs2"};